module.exports = __webpack_public_path__ + "static/media/Screenshot4.10bb7551.png";